import { amplifyProxy } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    currencyFilterData: '',
    loading: false,
    error: null
  },
  mutations: {
    SET_CURRENCY_DATA(state, data) {
      localStorage.setItem('currency', JSON.stringify(data))
      state.currencyFilterData = data
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async getCurrencyData({ commit, rootState }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const endpoint = `/${rootState.user.ClientName}/company/currency`
        const options = {
          headers: {
            token: rootState.user.LoginToken,

          }
        }

        const response = await amplifyProxy.get(endpoint, options)
        commit('SET_CURRENCY_DATA', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    currencyInfo(state) {
      if (!state.currencyFilterData) {
        try {
          const storedData = localStorage.getItem('currency')
          state.currencyFilterData = storedData ? JSON.parse(storedData) : ''
        } catch (error) {
          state.currencyFilterData = ''
        }
      }
      return state.currencyFilterData
    }
  }
}